import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType } from 'dashboard/models/account-type';
import {
  AccountStatusesActions,
  AccountStatusesActionType,
} from 'dashboard/redux/actions/account-statuses';

export interface AccountStatusesState {
  accountStatuses: AccountStatus[];
  accountType: AccountType;
}

export const initialAccountStatusesState: AccountStatusesState = {
  accountStatuses: [],
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  accountType: undefined,
};

export default (
  state: AccountStatusesState = initialAccountStatusesState,
  action: AccountStatusesActions,
) => {
  switch (action.type) {
    case AccountStatusesActionType.SetAccountStatuses: {
      return {
        ...state,
        accountStatuses: action.payload.accountStatuses,
        accountType: action.payload.accountType,
      };
    }
    case AccountStatusesActionType.AddAccountStatuses: {
      return {
        ...state,
        accountStatuses: [...state.accountStatuses, ...action.payload.accountStatuses],
      };
    }
    case AccountStatusesActionType.UpdateAccountStatus: {
      return {
        ...state,
        accountStatuses: state.accountStatuses.map((accountStatus) => {
          if (accountStatus.id === action.payload.accountStatus.id) {
            return action.payload.accountStatus;
          } else {
            return accountStatus;
          }
        }),
      };
    }
    case AccountStatusesActionType.UpdateDefaultGraphQueryTemplate: {
      return {
        ...state,
        accountType: {
          ...state.accountType,
          relationships: {
            ...state.accountType.relationships,
            'default-graph-query-template': {
              ...state.accountType.relationships['default-graph-query-template'],
              data: {
                ...state.accountType.relationships['default-graph-query-template'].data,
                id: action.payload.graphQueryTemplateId,
              },
            },
          },
        },
      };
    }

    default:
      return state;
  }
};
